import { render, staticRenderFns } from "./LabTypeSelect.vue?vue&type=template&id=73177ec0&"
import script from "./LabTypeSelect.vue?vue&type=script&lang=js&"
export * from "./LabTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports